import React, { Component } from "react";
import Uppy from '@uppy/core';
import { DashboardModal, Dashboard } from '@uppy/react'
import Transloadit from '@uppy/transloadit';
import GoogleDrive from '@uppy/google-drive';
import Instagram from '@uppy/instagram';
import Url from '@uppy/url';
import Webcam from '@uppy/webcam';
import { toast } from 'react-toastify';

import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import { UPPY_AWS_KEY, UPPY_AWS_SECRET_KEY, UPPY_BUCKET, UPPY_BUCKET_URL, UPPY_CAMPAION_URL, UPPY_KEY } from "../../../actions/constant";

const uppyKey = UPPY_KEY;
const uppyBucket = UPPY_BUCKET;
const uppyAwsKey = UPPY_AWS_KEY;
const uppyAwsSecret = UPPY_AWS_SECRET_KEY;
const companionUrl = UPPY_CAMPAION_URL;

class Uploader extends Component {

    constructor(props) {
        super(props);
        const { uploadPath, allowedFile, width, maxFileSize, beforeUpload, proceed } = props;
        const files = allowedFile ?? ['image/*'];
        const mediaW = width ?? 500;
        const fileSize = maxFileSize ?? 5000000;
        const autoProceed = proceed ?? false;
        const onBeforeUpload = beforeUpload ?? (() => { });
        const resizeStep = files.length > 1 ? {} : { resize: { robot: '/image/resize', width: mediaW, resize_strategy: 'fit', background: 'none' } };

        this.state = { filename: null, modalOpen: false, render: 0 };

        this.uppyPostEdit = new Uppy({
            debug: true, autoProceed, allowMultipleUploadBatches: false, restrictions: { maxFileSize: fileSize, maxNumberOfFiles: 1, minNumberOfFiles: 1, allowedFileTypes: files },
            onBeforeUpload: onBeforeUpload
        }).use(Transloadit, {
            target: '#a',
            params: {
                auth: { key: uppyKey },
                steps: { ...resizeStep, store: { robot: "/wasabi/store", bucket_region: "us-west-1", bucket: uppyBucket, key: uppyAwsKey, secret: uppyAwsSecret, path: `${uploadPath}` + '${file.id}' + '.${file.ext}' } }
            },
            waitForEncoding: true
        });
    }

    componentDidMount() {
        const { uploadAgents, uploadPath, onImgUpload, uploadMethods } = this.props;
        if (uploadAgents && uploadAgents.length > 0) {
            uploadAgents.forEach(element => {
                let agent = Instagram;
                if (element == 'GoogleDrive') agent = GoogleDrive;
                else if (element == 'Url') agent = Url;
                else if (element == 'Webcam') agent = Webcam;

                this.uppyPostEdit.use(agent, { target: Uppy.Dashboard, companionUrl: companionUrl })
            });
        }
        if (uploadMethods?.length > 0) {
            uploadMethods.forEach(({ key, callback }) => {
                this.uppyPostEdit.on(key, (file) => callback(file, this.uppyPostEdit));
            });
        }
        this.uppyPostEdit.on('transloadit:result', (stepName, result) => {
            const uploadedPath = `${UPPY_BUCKET_URL}${uploadPath}${result.id}.${result.ext}`;
            this.setState({ filename: uploadedPath }, () => {
                setTimeout(() => {
                    onImgUpload(uploadedPath, { ...result.meta, fileName: `${result.id}.${result.ext}`, isVideo: Object(result?.meta).hasOwnProperty("duration") }, uploadedPath);
                    this.uppyPostEdit.cancelAll()
                    this.setState({ modalOpen: false });
                }, 300)
            })
        })
        this.uppyPostEdit.on('transloadit:error', (error) => {
            toast.error(error.message || 'Upload failed', { autoClose: 2000 });
        })
        this.uppyPostEdit.on('upload-error', (file, error) => {
            toast.error(`${file.name}: ${error.message}`, { autoClose: 2000 });
        })
        this.uppyPostEdit.on('restriction-failed', (file, error) => {
            toast.error(error.message, { autoClose: 2000 });
        })
    }

    onClickToOpen = () => {
        const { handlePopUp } = this.props;
        if (handlePopUp) handlePopUp(true)
        else {
            this.setState({ modalOpen: true, renderKey: Math.floor(Math.random() * 6) + 1 })
            const element = document.querySelector(".uppy-Dashboard-close");
            if (element) {
                element.addEventListener('click', () => {
                    this.uppyPostEdit.cancelAll();
                    this.setState({ modalOpen: false, renderKey: Math.floor(Math.random() * 6) + 1 });
                })
            }
        }
    }

    onClickToClose = () => {
        this.uppyPostEdit.cancelAll()
        this.setState({ modalOpen: false, renderKey: Math.floor(Math.random() * 6) + 1 })
    }

    componentWillUnmount() {
        this.uppyPostEdit.cancelAll()
        this.uppyPostEdit.close({ reason: 'unmount' })
        this.setState({ modalOpen: false, renderKey: Math.floor(Math.random() * 6) + 1 })
    }

    render() {
        const { modalOpen, renderKey } = this.state;
        const { isModal = true, children, uploadAgents, showFile = false, disInfo = false, height = 270 } = this.props;

        return <React.Fragment key={renderKey}>{
            isModal ? <>
                <span onClick={this.onClickToOpen}>{children}</span>
                <DashboardModal
                    animateOpenClose={true}
                    proudlyDisplayPoweredByUppy={false}
                    inline={false}
                    open={modalOpen}
                    showProgressDetails={true}
                    height={750}
                    browserBackButtonClose={true}
                    showRemoveButtonAfterComplete={false}
                    uppy={this.uppyPostEdit}
                    onRequestCloseModal={this.onClickToClose}
                    closeAfterFinish={true}
                    doneButtonHandler={this.doneButtonHandler}
                    plugins={uploadAgents} />
            </> : <div><Dashboard
                proudlyDisplayPoweredByUppy={false}
                hideUploadButton={true}
                showProgressDetails={true}
                disableThumbnailGenerator={false}
                showRemoveButtonAfterComplete={false}
                height={height}
                uppy={this.uppyPostEdit}
                plugins={uploadAgents}
                showSelectedFiles={showFile}
                disableInformer={disInfo}
                key={renderKey}
            /></div>}
        </React.Fragment>
    }
}

export default Uploader;